import React from 'react';
import { LtNotificationsContext } from './LtNotificationsContext';

export default function useLtNotifications() {
  return React.useContext(LtNotificationsContext);
}
